import { Text } from '@chakra-ui/react'

const SettingsContent = () => {
  return <Text>Settings page placeholder</Text>
}

export default SettingsContent
